/**
 * Retrieves the query parameters from the current URL's search string.
 *
 * @returns {Record<string, string>} An object where keys are the query parameter names
 * and values are the corresponding parameter values.
 * @example
 * // If the URL is 'https://example.com/page?id=123&name=test'
 * const params = getQueryParams();
 * // params will be { id: '123', name: 'test' }
 */
export const getQueryParams = (): Record<string, string> => {
  const params = new URLSearchParams(window.location.search);
  const result: Record<string, string> = {};

  params.forEach((value, key) => {
    result[key] = value;
  });

  return result;
};
